const handleInitRelatedSlider = ({ id }) => {
  const pageWidth = document?.body?.offsetWidth;
  const isDesktop = pageWidth > DESKTOP_WIDTH;
  const productCountTarget = isDesktop ? 4 : 2;
  const carouselId = `related-product-carousel-${id}`;
  const carouselElement = document?.getElementById(carouselId);
  const { productCount } = carouselElement.dataset;
  const isEnabledAsBool = productCount > productCountTarget;
  const paginationId = `swiper-pagination-${id}`;
  const paginationEnabled = isEnabledAsBool && {
    pagination: {
      el: `#${paginationId}`,
      type: 'bullets',
    },
  };

  const navigationEnabled = isEnabledAsBool && {
    navigation: {
      nextEl: `#swiper-button-next-${id}`,
      prevEl: `#swiper-button-prev-${id}`,
    },
  };

  if (!carouselElement) {
    return null;
  }

  if (!isEnabledAsBool) {
    const navigationWrapper = document.getElementById(
      `swiper-navigation-wrapper-${id}`
    );

    navigationWrapper?.classList?.add('!hidden');
  }

  const swiper = new Swiper(`#${carouselId}`, {
    speed: DEFAULT_SLIDER_SPEED,
    spaceBetween: 4,
    loop: false,
    slidesPerView: 1.5,
    centeredSlides: false,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      [DESKTOP_WIDTH]: {
        slidesPerView: 4.5,
        spaceBetween: 16,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
      },
    },
    ...navigationEnabled,
    ...paginationEnabled,
    on: {
      init: function () {
        this?.el?.classList.remove('opacity-0');
        this?.wrapperEl?.classList.remove(
          'items-center',
          'justify-center',
          'gap-4'
        );
      },
    },
    watchOverflow: true,
  });

  return swiper;
};

const handleSetRecommendedData = (section, text, id) => {
  if (!text && !section) {
    return null;
  }

  const html = document.createElement('div');
  html.innerHTML = text;

  const recommendations = html.querySelector(`#${id}`);

  if (recommendations && recommendations.innerHTML.trim().length) {
    section.innerHTML = recommendations.innerHTML;
    handleInitRelatedSlider({
      id: id,
    });
  }
};

const handleInitRecommendedData = (entries, observer) => {
  if (!entries?.[0]?.isIntersecting) {
    return null;
  }

  const { id, url } = entries?.[0]?.target.dataset;
  const productRecommendationsSection = document?.getElementById(id);

  if (!productRecommendationsSection) {
    return null;
  }

  observer.unobserve(productRecommendationsSection);

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      handleSetRecommendedData(productRecommendationsSection, text, id);
    })
    .catch((e) => {
      console.error(e);
    });
};

const handleRelatedObserver = (element) => {
  const viewportHeight = `${Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)}px`;

  const observer = new IntersectionObserver(handleInitRecommendedData, {
    rootMargin: viewportHeight,
  });

  observer.observe(element);
};

const handleInitRelatedProduct = () => {
  const productRecommendationsSection = document?.querySelectorAll(
    '.js-product-recommendations'
  );

  if (productRecommendationsSection?.length == 0) {
    return null;
  }

  productRecommendationsSection.forEach((element) => {
    handleRelatedObserver(element);
  });
};

window.addEventListener('product-info:loaded', handleInitRelatedProduct);
